// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** French Guiana */
const GF = /^(?:(?:694(?:[0-249]\d|3[0-8])|7093[0-3])\d{4})$/;

export default GF;
